import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Logo from '../Logo';

const Header = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = async () => {
        await logout();
        navigate('/');
    };

    return (
        <>
            <header className="bg-white border-b border-gray-100 relative z-50">
                <div className="w-full px-4 py-4 flex items-center justify-between">
                    <Link to="/" className="ml-4">
                        <Logo width="208" height="32" textFill="black" />
                    </Link>
                    <div className="hidden md:flex items-center gap-8 mr-4">
                        <a href="https://blog.remote-assistant.ai" className="text-gray-700 text-sm font-medium hover:text-blue-600 transition-colors">
                            Blog
                        </a>
                        {user ? (
                            <>
                                <Link to="/dashboard" className="text-gray-700 text-sm font-medium hover:text-blue-600 transition-colors">
                                    Dashboard
                                </Link>
                                <button onClick={handleLogout} className="text-gray-700 text-sm font-medium hover:text-blue-600 transition-colors">
                                    Logout
                                </button>
                            </>
                        ) : (
                            <>
                                <Link to="/login" className="text-gray-700 text-sm font-medium hover:text-blue-600 transition-colors">
                                    Login
                                </Link>
                                <Link to="/signup">
                                    <div className="px-6 py-2.5 bg-blue-600 rounded !text-stone-100 text-sm font-bold hover:bg-blue-700 transition-colors">
                                        Join Waitlist
                                    </div>
                                </Link>
                            </>
                        )}
                    </div>
                    <button 
                        onClick={() => setMobileMenuOpen(true)}
                        className="md:hidden text-gray-700 hover:text-blue-600 mr-4"
                    >
                        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                        </svg>
                    </button>
                </div>
            </header>

            {mobileMenuOpen && (
                <div className="fixed inset-0 bg-white z-50 md:hidden">
                    <div className="flex flex-col h-full">
                        <div className="flex items-center justify-between p-4 border-b border-gray-100">
                            <Link to="/" onClick={() => setMobileMenuOpen(false)}>
                                <Logo width="208" height="32" textFill="black" />
                            </Link>
                            <button 
                                onClick={() => setMobileMenuOpen(false)}
                                className="text-gray-700 hover:text-blue-600"
                            >
                                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div className="flex flex-col items-center justify-center flex-1 gap-8 p-8">
                            <a 
                                href="https://blog.remote-assistant.ai"
                                className="text-gray-700 text-2xl font-medium hover:text-blue-600 transition-colors"
                            >
                                Blog
                            </a>
                            {user ? (
                                <>
                                    <Link 
                                        to="/dashboard"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="text-gray-700 text-2xl font-medium hover:text-blue-600 transition-colors"
                                    >
                                        Dashboard
                                    </Link>
                                    <button 
                                        onClick={() => { handleLogout(); setMobileMenuOpen(false); }}
                                        className="text-gray-700 text-2xl font-medium hover:text-blue-600 transition-colors"
                                    >
                                        Logout
                                    </button>
                                </>
                            ) : (
                                <>
                                    <Link 
                                        to="/login"
                                        onClick={() => setMobileMenuOpen(false)}
                                        className="text-gray-700 text-2xl font-medium hover:text-blue-600 transition-colors"
                                    >
                                        Login
                                    </Link>
                                    <Link to="/signup" onClick={() => setMobileMenuOpen(false)}>
                                        <div className="px-8 py-4 bg-blue-600 rounded text-white text-xl font-bold hover:bg-blue-700 transition-colors">
                                            Join Waitlist
                                        </div>
                                    </Link>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Header;
